<template>
  <div class="page">
    <div class="weui-cell weui-cell_active" >
      <div class="weui-cell__hd"><label class="weui-label">地址</label></div>
      <div class="weui-cell__bd weui-flex">
          <input  class="weui-input" autofocus type="text" placeholder="请输入地址" maxlength="64" :value="showdata.address"/>
          <button id="js_input_clear" class="weui-btn_reset weui-btn_icon weui-btn_input-clear">
            <i class="weui-icon-clear"></i>
          </button>
      </div>
    </div>
    <div class="weui-cell weui-cell_active" >
      <div class="weui-cell__hd"><label class="weui-label">经纬度</label></div>
      <div class="weui-cell__bd weui-flex">
          <input  class="weui-input" autofocus type="text" placeholder="请输入经度" maxlength="64" :value="showdata.longitude"/>,
          <input  class="weui-input" autofocus type="text" placeholder="请输入纬度" maxlength="64" :value="showdata.latitude"/>
          <i class="bi bi-geo-fill"></i>
      </div>
    </div>
    <div class="weui-cell weui-cell_active" >
      <div class="weui-cell__hd"><label class="weui-label">联系电话</label></div>
      <div class="weui-cell__bd weui-flex">
          <input  class="weui-input" autofocus type="text" pattern="[0-9]*" placeholder="请输入电话号码" maxlength="16" :value="showdata.phone"/>
          <button id="js_input_clear" class="weui-btn_reset weui-btn_icon weui-btn_input-clear">
            <i class="weui-icon-clear"></i>
          </button>
      </div>
    </div>
    <div class="weui-cell weui-cell_active" >
      <div class="weui-cell__hd"><label class="weui-label">营业时间</label></div>
      <div class="weui-cell__bd weui-flex">
          <input  class="weui-input center" autofocus type="text" pattern="[0-9]*" placeholder="开始时间" maxlength="2" :value="beginHour" @click="pickHour(true)" /> ~
          <input  class="weui-input center" autofocus type="text" pattern="[0-9]*" placeholder="结束时间" maxlength="2" :value="endHour" @click="pickHour(false)"/>
      </div>
    </div>
    <div class="weui-cell weui-cell_active weui-cell_switch">
        <div class="weui-cell__bd"><label class="weui-label">快洗</label></div>
        <div class="weui-cell__ft">
            <label for="switch_KX" class="weui-switch-cp">
                <input id="switch_KX" class="weui-switch-cp__input" type="checkbox" checked="checked"/>
                <div class="weui-switch-cp__box" @click="clickSwitch(4)"></div>
            </label>
        </div>
    </div>
    
    <div class="weui-cell weui-cell_active" v-if="kx">
      <div class="weui-cell__hd"><label class="weui-label">快洗价格</label></div>
      <div class="weui-cell__bd weui-flex">
          <input  class="weui-input  right" autofocus type="text" pattern="[0-9]*" placeholder="输入快洗门市价" maxlength="16" value="28"/>
      </div>
    </div>
    <div class="weui-cell weui-cell_active weui-cell_switch">
        <div class="weui-cell__bd"><label class="weui-label">精洗</label></div>
        <div class="weui-cell__ft">
            <label for="switch_JX" class="weui-switch-cp">
                <input id="switch_JX" class="weui-switch-cp__input" type="checkbox" checked="checked"/>
                <div class="weui-switch-cp__box" @click="clickSwitch(2)"></div>
            </label>
        </div>
    </div>
    
    <div class="weui-cell weui-cell_active" v-if="jx">
      <div class="weui-cell__hd"><label class="weui-label">精洗价格</label></div>
      <div class="weui-cell__bd weui-flex">
          <input  class="weui-input  right" autofocus type="text" pattern="[0-9]*" placeholder="输入快洗门市价" maxlength="16" value="35"/>
      </div>
    </div>

    <div class="weui-cell weui-cell_active weui-cell_switch">
        <div class="weui-cell__bd"><label class="weui-label">超洗</label></div>
        <div class="weui-cell__ft">
            <label for="switch_CX" class="weui-switch-cp">
                <input id="switch_CX" class="weui-switch-cp__input" type="checkbox" checked="checked"/>
                <div class="weui-switch-cp__box" @click="clickSwitch(1)"></div>
            </label>
        </div>
    </div>
    
    <div class="weui-cell weui-cell_active" v-if="cx">
      <div class="weui-cell__hd"><label class="weui-label">超洗价格</label></div>
      <div class="weui-cell__bd weui-flex">
          <input  class="weui-input  right" autofocus type="text" pattern="[0-9]*" placeholder="输入快洗门市价" maxlength="16" value="60"/>
      </div>
    </div>
</div>
<!--
<div class="page">
    <div class="page__hd">
        <h1 class="page__title">Picker</h1>
        <p class="page__desc">多列选择器，需要配合js实现</p>
    </div>
    <div class="page__bd page__bd_spacing">
        <a href="javascript:" class="weui-btn weui-btn_default" id="showPicker">单列选择器</a>
        <a href="javascript:" class="weui-btn weui-btn_default" id="showDatePicker">日期选择器</a>
    </div>
</div>
-->


</template>

<script>
  import JQ from 'jquery'
  import pieGraph from '../components/pie.vue'
  import axios from 'axios'
  import 'bootstrap/dist/css/bootstrap.css'
  
  export default {
  
    data () {
      return {
        posSelected:{label: '请选择',
            value: 0},
            posList: [{
            label: '请选择',
            value: 0
        }], 
        partnerid:"",
        kx:true,
        cx:true,
        jx:true,
        beginHour : 0,
        endHour: 24,
        dateStr : new Date().Format("yyyy-MM-dd"),
        selPos: {'label':'缺省','value':'000'},
        showdata : []
      }
    },
    mounted() {
      const {name,xData,yData} = this
      this.partnerid = sessionStorage.getItem("partnerid")
      this.initPosList(this.partnerid)
      
         console.log(this.$refs)
         console.log(this.posList)
         this.getshowdata()
         // this.$refs.chart_line_one.initChart(name,xData,yData)
         //this.$refs.chart_line_box.initChart(name,xData,yData)
      
    },
    methods: {
      clickSwitch(evt){
        console.log(evt);
        switch(evt){
          case 4: this.kx = ! this.kx; break;
          case 2: this.jx = ! this.jx; break;
          case 1: this.cx = ! this.cx; break;
        }
        
      },
      initPosList(pid){
       let pelist = JSON.parse(sessionStorage.getItem("posListOf_"+pid));

       console.log(pelist,pid)
       
       pelist.forEach(item => {
        let tmp={};
        tmp.label = item.name;
        tmp.value = item.posId;

        this.posList.push(tmp);
       });

       /*
       this.posList.push({
            label: '所有',
            value: 0
        });*/
       
    },
      pickHour(flag) {
        let that = this;
        let optionHour = [];
        for(var i=0;i<=24;i++){
          optionHour.push({"label":i,"value":i});
        }
        this.$weui.picker(optionHour, {
                onChange: function (result) {
                    console.log(result,result[0]);
                    if(flag) that.beginHour = result[0].value;
                    else that.endHour = result[0].value;
                },
                onConfirm: function (result) {
                    console.log(result,result[0]); 
                    if(flag) that.beginHour = result[0].value;
                    else that.endHour = result[0].value;
                },
                title: '单列选择器'
            });
      },
      pickPos() {
      let that = this;
      this.$weui.picker(this.posList, {
            onChange: function (result) {
                console.log(result);
                that.posSelected = result[0]
            },
            onConfirm: function (result) {
                console.log(result);
                that.getshowdata();
            },
            title: '选择网点'
        });
    },
    showError(){
      var $warnToast = JQ('#warnToast');
      $warnToast.fadeIn(100);
      setTimeout(function () {
          $warnToast.fadeOut(100);
      }, 2000);
    },
    POSDATA() {
      let posdata = new Map();
      posdata.clear();
      let val_org = {
        
        "address":'',
        "longitude":'',
        "latitude":'',
        "phone":'',
        
      };
      
      console.log(posdata)

      return posdata;

    },
    getshowdata(dstr){

      console.log("showdata")
      let that = this;
      this.ing=true;
      axios.get('/pccs-common-query/posEntities/search/findByPosId?posId='+this.posSelected.value).then(res  =>  {
        console.log(res.data)  
        if((res.data == null)) {
          that.showError();return;
        }

        if(this.posSelected.value==0){return;}
        let posdata = this.POSDATA();
        this.showdata=res.data
        console.log(this.showdata)
        
      })
      
    },
        pickerDate() {
        let that = this;
        this.$weui.datePicker({
              start: 1990,
              end: new Date().getFullYear(),
              onChange: function (result) {
                  console.log(result);
                  console.log(result[0].value +"-"+ result[1].value +"-"+ result[2].value );
                  that.dateStr = result[0].value +"-"+ result[1].value +"-"+ result[2].value;
              },
              onConfirm: function (result) {
                  console.log(result);
              },
              title: '多列选择器'
          });
      },
      handleClick () {
        this.$weui.dialog({
          title: '提示',
          content: '是否领取礼品',
          buttons: [{
              label: '取消',
              type: 'default',
              onClick: () => {
                console.log('您已取消领取礼品！')
              }
            }, {
              label: '确定',
              type: 'primary',
              onClick: () => {
              console.log('您已确定领取礼品！')
              }
            }
          ]
        })
      }
    }
  }
  </script>

  <style>
    input.right{align-content: right;text-align: right;align-self: right;width:3em}
    input.center{align-content: center;text-align: center;align-self: center;width:3em}
  </style>


// WEBPACK FOOTER //
// src/views/config_pos.vue